import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { homePathFor } from '../../utils/access';

/** "/" for the front desk (viewer) redirects to its events list (#71); everyone else sees the page. */
export const HomeRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const home = homePathFor(user?.role);
  if (home !== '/') return <Navigate to={home} replace />;
  return <>{children}</>;
};
